module.exports = __webpack_public_path__ + "img/moon.9fae7645.svg";